module.exports = __webpack_public_path__ + "static/img/萌小白.aba62531.png";